import type { PermissionMap, SystemRole } from '@/types/permission.types'
import {
  apiGet,
  apiPostResult,
  apiPutResult,
} from '@/services/api/http'
import type { AxiosRequestConfig } from 'axios'

export type ConfigurableRole = Exclude<SystemRole, 'super_admin'>

export type RolePermissionsPayload = Record<ConfigurableRole, PermissionMap>

export type RolePermissionUpdateResult = {
  role: ConfigurableRole
  permissions: PermissionMap
}

function normalizeMaps(payload: Partial<RolePermissionsPayload>): RolePermissionsPayload {
  return {
    manager: payload.manager ?? {},
    assistant: payload.assistant ?? {},
    salesman: payload.salesman ?? {},
  }
}

export const rolePermissionsService = {
  async list(config?: AxiosRequestConfig): Promise<RolePermissionsPayload> {
    const data = await apiGet<Partial<RolePermissionsPayload>>('/role-permissions', config)
    return normalizeMaps(data ?? {})
  },

  async update(
    role: ConfigurableRole,
    permissions: PermissionMap,
  ): Promise<RolePermissionUpdateResult> {
    const { data, message } = await apiPutResult<RolePermissionUpdateResult, PermissionMap>(
      `/role-permissions/${role}`,
      permissions,
    )
    void message
    return {
      role: data.role,
      permissions: data.permissions ?? {},
    }
  },

  async reset(): Promise<RolePermissionsPayload> {
    const { data } = await apiPostResult<Partial<RolePermissionsPayload>>(
      '/role-permissions/reset',
    )
    return normalizeMaps(data ?? {})
  },
}
